/** 案件包导出、阶段主管权和案件包签名密钥（第二阶段 P2-3）。 */
export default {
  export: {
    title: '案件包',
    open: '导出案件包',
    intro: '案件包将此申请的完整历史打包为一个已签名的文件，其他系统可以校验并导入。',
    profile: '包含内容',
    profiles: {
      full: '完整记录',
      interagency: '供其他机构使用（不含申请人联系方式）',
      party: '供申请人使用',
      public: '公开（不含个人数据）',
      archive: '存档（全部内容，含检查报告和流程）',
    },
    boundary: '移交节点',
    boundaries: {
      submission: '提交',
      supplement_withdraw: '补充或撤回',
      referral: '转交机构征询',
      forward: '移交其他主管机关',
      decision: '决定',
      post_decision: '决定之后',
      register: '登记册或统计',
      snapshot: '当前状态（无移交）',
    },
    recipient: '接收系统',
    recipientHint: '您为接收系统使用的标识，小写，例如 mbjb-osc。',
    recipientInvalid: '请使用小写字母、数字、点、连字符或下划线，并以字母或数字开头。',
    forwardWarning: '移交会将此申请交给接收系统。在管理员收回之前，此处无法进行任何更改。',
    start: '创建案件包',
    status: {
      queued: '等待开始…',
      running: '正在生成案件包…',
      done: '案件包已就绪。',
      failed: '案件包无法生成。',
      expired: '案件包已过期并已删除，请重新创建。',
    },
    download: '下载案件包',
    close: '关闭',
    asAt: '截至第 {{seq}} 个事件的历史',
    errors: {
      EXPORT_FAILED: '生成案件包时出错，请重试。',
      EXPORT_CHAIN_BROKEN: '此申请的历史未通过验证，因此无法导出。',
      EXPORT_DOCUMENT_MISSING: '此申请的一个文件在存储中缺失。',
      EXPORT_DOCUMENT_MISMATCH: '已存储的文件与历史记录不再一致。',
      EXPORT_REPORT_MISMATCH: '检查报告与历史记录不再一致。',
      EXPORT_LETTER_INPUT_MISMATCH: '决定函文件与历史记录不再一致。',
      EXPORT_PUBLIC_UNSAFE: '此申请的历史包含明文个人数据，因此无法生成公开案件包。',
      EXPORT_TOO_LARGE: '案件包将超过 4 GB。',
      EXPORT_SEAL_KEY_UNAVAILABLE: '无法使用案件包签名密钥。管理员必须在“设置 → 规划”中更换。',
      EXPORT_GEOMETRY_FAILED: '无法从地图登记册读取地块。',
      EXPORT_BOUNDARY_NOT_REACHED: '此申请尚未到达该移交节点。',
      EXPORT_SEAL_KEY_REVOKED: '签署此案件包的密钥已被吊销。请重新创建案件包，以新密钥签名。',
      EXPORT_STALE: '案件包生成意外中断，请重新创建。',
    },
  },
  authority: {
    heldTitle: '由其他系统持有',
    heldBody: '此申请已于 {{date}} 移交给 {{holder}}。在收回之前，此处的操作会被拒绝。',
    heldBodyUnnamed: '此申请已于 {{date}} 移交给其他系统。在收回之前，此处的操作会被拒绝。',
    recall: '收回',
    recallTitle: '收回此申请',
    recallBody: '从 {{holder}} 收回此申请，并告知接收系统您已收回。',
    reasonLabel: '原因',
    reasonRequired: '请输入原因。',
    confirm: '收回申请',
    cancel: '取消',
  },
  sealKey: {
    title: '案件包签名密钥',
    description: '案件包使用此密钥签名。接收系统会根据已发布的密钥列表校验签名。',
    active: '正在使用的密钥：{{kid}}',
    created: '创建于 {{date}}',
    none: '尚无密钥。生成第一个案件包时会创建一个。',
    retired: '以前的密钥（仍在发布，以便以前的案件包仍可验证）',
    jwksUrl: '密钥列表地址',
    copy: '复制地址',
    copied: '已复制',
    download: '下载密钥列表',
    rotate: '更换密钥',
    rotateConfirm: '要更换签名密钥吗？新的案件包将使用新密钥签名；旧密钥仍会发布。',
    rotated: '签名密钥已更换。',
    cancel: '取消',
    revokePrevious: '旧密钥可能已泄露：吊销它，使其签署的任何内容都不再能通过验证',
    revokeConfirm:
      '要更换签名密钥并吊销旧密钥吗？旧密钥将不再发布，因此其签署的任何内容都不再能通过验证，由其签署的每个已完成案件包都必须重新创建。',
    revoked: '已吊销的密钥（不再发布）',
  },
  errors: {
    invalid_export: '这些导出选项无效。',
    public_export_unsafe: '此申请的历史包含明文个人数据，因此无法生成公开案件包。',
    boundary_not_reached: '此申请尚未到达该移交节点。请按当前状态导出。',
    stage_held_externally: '此申请由其他系统持有。必须先由管理员收回。',
    not_held_externally: '没有其他系统持有此申请。',
    intake_in_progress: '图纸检查仍在进行。请在检查完成后再移交此申请。',
    export_not_found: '未找到该案件包。',
    export_not_ready: '该案件包尚未就绪。',
    export_expired: '该案件包已过期并已删除，请重新创建。',
    too_many_exports: '您已有三个案件包正在生成。请等待其中一个完成。',
  },
  events: {
    case_authority_transferred: '已移交给其他系统',
    case_authority_returned: '已从其他系统收回',
  },
} as const
